module.exports = __webpack_public_path__ + "img/trip-to-nowhere.32f505fe.jpg";